const storageManager = App.es6.shared.storage_manager().init('local');

const STORAGE_KEY_SOURCE = 'UTM_SOURCE_v1';
const STORAGE_KEY_MEDIUM = 'UTM_MEDIUM_v1';
const STORAGE_KEY_KEYWORD = 'UTM_KEYWORD_v1';
const STORAGE_KEY_CAMPAIGN = 'UTM_CAMPAIGN_v1';
const STORAGE_KEY_ADGROUP = 'UTM_ADGROUP_v1';
const STORAGE_KEY_CLICK_ID = 'CLICK_ID_v1';

export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmKeyword = params.get('utm_keyword');
  const utmCampaign = params.get('utm_campaign');
  const utmAdgroup = params.get('utm_adgroup');
  const clickId = params.get('gclid') || params.get('msclkid') || params.get('fbclid');

  if (utmSource) {
    storageManager.set(STORAGE_KEY_SOURCE, utmSource);
  }

  if (utmMedium) {
    storageManager.set(STORAGE_KEY_MEDIUM, utmMedium);
  }

  if (utmKeyword) {
    storageManager.set(STORAGE_KEY_KEYWORD, utmKeyword);
  }

  if (utmCampaign) {
    storageManager.set(STORAGE_KEY_CAMPAIGN, utmCampaign);
  }

  if (utmAdgroup) {
    storageManager.set(STORAGE_KEY_ADGROUP, utmAdgroup);
  }

  if (clickId) {
    storageManager.set(STORAGE_KEY_CLICK_ID, clickId);
  }
}

export function getCapturedUtmParams() {
  return {
    utmSource: storageManager.get(STORAGE_KEY_SOURCE) || null,
    utmMedium: storageManager.get(STORAGE_KEY_MEDIUM) || null,
    utmKeyword: storageManager.get(STORAGE_KEY_KEYWORD) || null,
    utmCampaign: storageManager.get(STORAGE_KEY_CAMPAIGN) || null,
    utmAdgroup: storageManager.get(STORAGE_KEY_ADGROUP) || null,
    clickId: storageManager.get(STORAGE_KEY_CLICK_ID) || null,
  };
}
